import { Controller } from '@hotwired/stimulus'

let consentRoot = null

export default class extends Controller {
  connect() {
    window.addEventListener('tac.root_available', this.#captureConsentRoot)
    this.#restoreConsentRoot()
  }

  disconnect() {
    window.removeEventListener('tac.root_available', this.#captureConsentRoot)
  }

  #captureConsentRoot = () => {
    consentRoot = document.getElementById('tarteaucitronRoot')
  }

  #restoreConsentRoot() {
    if (consentRoot === null || consentRoot.isConnected) return

    this.element.append(consentRoot)
  }
}
